import api from "./api";

const holidayService = {
  list() {
    return api.get("/holidays");
  },
  show(id) {
    return api.get(`/holidays/${id}`);
  },
  create(data) {
    return api.post("/holidays", data);
  },
  update(id, data) {
    return api.put(`/holidays/${id}`, data);
  },
  remove(id) {
    return api.delete(`/holidays/${id}`);
  }
};

export default holidayService;

